import { render, staticRenderFns } from "./supplierDeliveryStats.vue?vue&type=template&id=222c471a&scoped=true&"
import script from "./supplierDeliveryStats.vue?vue&type=script&lang=js&"
export * from "./supplierDeliveryStats.vue?vue&type=script&lang=js&"
import style0 from "./supplierDeliveryStats.vue?vue&type=style&index=0&id=222c471a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222c471a",
  null
  
)

export default component.exports